import React from 'react';
import styles from '../../styles/ReporteEficienciaStyles/ReporteEficiencia.module.css';

/**
 * Resumen ejecutivo del Reporte de Eficiencia Terminal (solo lectura).
 *
 * Muestra:
 *  - % Eficiencia Terminal (verde): alumnos con estatus EGRESADO / total.
 *  - Total General (azul): total de alumnos del universo filtrado.
 *  - Bloque dinámico de tarjetas por estatus: se genera según los estatus
 *    presentes en los datos (nombre, cantidad y porcentaje). La suma de los
 *    porcentajes es exactamente 100%.
 *
 * Props:
 *  - resumen: { total, egresados, eficiencia_pct, estatus_distribucion:
 *               [{ estatus, label, cantidad, porcentaje }] }
 */

// Acentos suaves por estatus (consistentes con el diseño institucional).
// Cualquier estatus no listado usa un color neutro de respaldo.
const ESTATUS_COLORES = {
  ACTIVO:          '#1f7a3a',
  EGRESADO:        '#1a4f8b',
  PASANTE:         '#7a5b1f',
  BAJA_TEMPORAL:   '#c58a1f',
  BAJA_DEFINITIVA: '#c5221f',
  NO_INSCRITO:     '#777777',
};

function IndicadoresReporte({ resumen }) {
  if (!resumen) return null;

  const {
    eficiencia_pct = 0,
    total = 0,
    estatus_distribucion = [],
  } = resumen;

  return (
    <>
      <div className={styles.indicadoresRow}>
        <div className={`${styles.indicadorCard} ${styles.indicadorCardEficiencia}`}>
          <span className={styles.indicadorLabel}>Porcentaje de Eficiencia Terminal</span>
          <div className={styles.indicadorValueRow}>
            <span className={`${styles.indicadorValueStatic} ${styles.indicadorEficienciaValue}`}>
              {eficiencia_pct}
            </span>
            <span className={`${styles.indicadorSuffix} ${styles.indicadorEficienciaValue}`}>%</span>
          </div>
        </div>

        <div className={`${styles.indicadorCard} ${styles.indicadorCardTotal}`}>
          <span className={styles.indicadorLabel}>Total General</span>
          <div className={styles.indicadorValueRow}>
            <span className={`${styles.indicadorValueStatic} ${styles.indicadorTotalValue}`}>{total}</span>
          </div>
        </div>
      </div>

      {estatus_distribucion.length > 0 && (
        <div className={styles.estatusGrid}>
          {estatus_distribucion.map((e) => {
            const color = ESTATUS_COLORES[e.estatus] || '#607d8b';
            return (
              <div
                key={e.estatus || 'sin_estatus'}
                className={styles.estatusCard}
                style={{ borderLeftColor: color }}
              >
                <span className={styles.estatusLabel}>{e.label}</span>
                <div className={styles.estatusValueRow}>
                  <span className={styles.estatusPct} style={{ color }}>{e.porcentaje}%</span>
                  <span className={styles.estatusCount}>
                    {e.cantidad} alumno{e.cantidad === 1 ? '' : 's'}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

export default IndicadoresReporte;
